<template>
	<div>
		<egranty-section-divider 
			text="Geograficzny podział środków"
			icon="public"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>
		<v-card>
			<v-flex sm5 ml-3 py-3>
				<v-layout
					align-baseline=true
					row
					:key='index'
					v-for="(val,index) in data.countriesFundings"
				>
					<div class="country-name">
						<strong>{{currentNames[index]}}</strong>
					</div>
					<v-slider
						:disabled="readonly"
						v-if="data.countriesFundings[1] !== undefined && !readonly"
						v-model='data.countriesFundings[index].value'
						:max=100
						@input="edit(index)"
					></v-slider>

					<input
						type="number"
						value="value"
						v-model="val.value"
						v-if="data.countriesFundings[1] !== undefined && !readonly"
						:min="0"
						:max="100"
						@input="editText(index)"
						style="text-align:right"
					/>
					<div v-if="readonly && data.countriesFundings[1] !== undefined">
						{{val.value}}
					</div>
					<p v-if="data.countriesFundings[1] !== undefined" class="mb-0">%</p>
					<p v-if="data.countriesFundings[1] === undefined" class="mb-0" style="width:100px">100 % </p>
					<div v-if="!readonly && data.countriesFundings.length > 1">
						<v-icon @click="increment(index)" flat >
							add
						</v-icon>
						<v-icon @click="decrement(index)" flat>
							remove
						</v-icon>
					</div>
				</v-layout>
			</v-flex>
		</v-card>
	</div>
</template>

<script>
	import {TaskAccreditationCountry} from "@/api/generated/TaskAccreditationCountry";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "ChooseFunding",
		components: {EgrantySectionDivider},
		methods: {

			increment(index) {
				this.data.countriesFundings[index].value++;
				this.editText(index);
			},

			decrement(index) {
				this.data.countriesFundings[index].value--;
				this.editText(index);
			},

			edit(index) {
				let last = this.data.countriesFundings.length - 1;
				let fundings = this.data.countriesFundings;

				//wartość, o którą musimy zmienić sumę sliderów
				let excess = -100;
				for (var i = 0; i < fundings.length; i++) {
					excess += fundings[i].value;
				}


				for (i = last; i >= 0; i--) {
					//nie ruszamy wartości slidera, który jest aktualnie edytowany
					if (i === index) {
						continue;
					}
					let change = Math.min(fundings[i].value, excess);
					fundings[i].value -= change;
					excess -= change;
				}

				this.$emit("input", this.data);
			},

			editText (index) {
				let last = this.data.countriesFundings.length - 1;
				if (this.data.countriesFundings[index].value === "" || isNaN(this.data.countriesFundings[index].value)) {
					this.data.countriesFundings[index].value = 0;
				} else {
					this.data.countriesFundings[index].value = parseInt(this.data.countriesFundings[index].value, 10);
					if (this.data.countriesFundings[index].value > 100) {
						this.data.countriesFundings[index].value = 100;
					}
				}
				let fundings = this.data.countriesFundings;

				//wartość, o którą musimy zmienić sumę sliderów
				let excess = -100;
				for (var i = 0; i < fundings.length; i++) {
					excess += fundings[i].value;
				}


				for (i = last; i >= 0; i--) {
					//nie ruszamy wartości slidera, który jest aktualnie edytowany
					if (i === index) {
						continue;
					}
					let change = Math.min(fundings[i].value, excess);
					fundings[i].value -= change;
					excess -= change;
				}
				this.$emit("input", this.data);
			},

			refresh() {
				TaskAccreditationCountry.getAvailableCountries(
					this,
					this.contestId,
					response => {
						this.countries = response;
						this.updateCurrentCountries();
					},
				);

			},

			findCountryById(id) {
				var country = this.countries.find(x => x.id === id);
				if (country === undefined) {
					return undefined;
				}
				return country.name;
			},

			updateCurrentCountries() {
				this.currentNames = [];
				for (let i = 0; i < this.data.countriesFundings.length; i++) {
					this.currentNames.push(this.findCountryById(this.data.countriesFundings[i].id));
				}

			},
		},


		data() {
			return {
				countries: [],
				currentNames: [],
				data: {
					countriesFundings: [],
				},
				minFunding: 0,
				maxFunding: 0,
				fundingError: ""
			};
		}
		,

		watch: {

			value: {
				immediate: true,
				deep:
					true,
				handler(val) {
					if (val)
						this.data = val;
				},
			}
			,

			input: {
				immediate: true,
				deep:
					true,
				handler(val) {
					if (!this.countriesChanged) {
						this.updateCurrentCountries();
						return;
					}

					this.data.countriesFundings = [];
					this.currentNames = [];
					if (val.mainCountryId !== undefined) {
						this.data.countriesFundings.push({id: val.mainCountryId, value: 100});
						this.currentNames.push(this.findCountryById(val.mainCountryId));
					}
					for (var i = 0; i < val.extraCountries.length; i++) {
						for (i = 0; i < val.extraCountries.length; i++) {
							this.data.countriesFundings.push({id: val.extraCountries[i], value: 0});
							this.currentNames.push(this.findCountryById(val.extraCountries[i]));
						}
					}
					this.$emit("update:countriesChanged", false);
					this.$emit("input", this.data);
				},
			},
		}

		,

		mounted() {
			this.refresh();
		}
		,


		props: {
			input: {},
			value: {},
			countriesChanged: {},
			contestId: null,
			readonly: {
				default: false
			},
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};

</script>

<style scoped>
	.country-name {
		width: 180px;
		overflow-wrap: break-word;
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type=number] {
		-moz-appearance:textfield;
	}

</style>
